define(['underscore'], (_)=> {
    return ['$window', ($window)=> {
        const windowEl = angular.element($window);

        return {
            restrict: 'A',
            scope: {},

            link: (scope, element)=> {
                let startYOffset;
                let isPositionedByTransform = false;

                const throttleRunChecks = _.debounce(()=> {
                    checkPosition();
                }, 50);

                scope.$on('CustomQuoteSelected', ()=> {
                    //have to wait until custom tab is selected and tab contents are visible until top coordinate can be retrieved
                    $window.setTimeout(()=> {
                        startYOffset = startYOffset || angular.element(element).offset().top;
                        checkPosition();
                    }, 1000);
                });


                //check if node needs to be positioned
                function checkPosition() {
                    const repositionViaTransform = windowEl.scrollTop() > startYOffset;
                    if (repositionViaTransform || repositionViaTransform !== isPositionedByTransform) {
                        isPositionedByTransform = repositionViaTransform;
                        handleNodeRepositioning();
                    }
                }

                //position element either fixed or normal
                function handleNodeRepositioning() {
                    if (isPositionedByTransform) {
                        //postion comparison panel 5px down from viewport
                        const scollPosition = windowEl.scrollTop() - startYOffset;

                        element.css({
                            transform: `translateY(${scollPosition}px)`,
                            position: 'relative',
                            'z-index': 100,
                        });
                    } else {
                        element.css({
                            transform: '',
                            'z-index': '',
                        });
                    }
                }

                windowEl.on('scroll resize', throttleRunChecks);
                scope.$on('$destroy', ()=> {
                    windowEl.off('scroll resize');
                });
            },
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/directives/QuoteComparisonPanel.js